export const appBarStyles = {
  logoutContainer: {
    pl: "2rem",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoutIcon: {
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
      filter: "brightness(1.2)",
    },
    width: "1.5rem",
    height: "1.5rem",
  },
  hoverIcon: {
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.5)",
      filter: "brightness(1.2)",
    },
  },
};
